export enum ChatLlmModelsEnum {
	// Anthropic
	ANTHROPIC_CLAUDE_FABLE_5 = 'claude-fable-5',
	ANTHROPIC_CLAUDE_FABLE_5_1 = 'claude-fable-5-1',
	ANTHROPIC_CLAUDE_OPUS_5 = 'claude-opus-5',
	ANTHROPIC_CLAUDE_SONNET_5 = 'claude-sonnet-5',
	ANTHROPIC_CLAUDE_HAIKU_4_5 = 'claude-haiku-4-5',
	// OpenAI
	OPENAI_GPT_6_ASTRA = 'gpt-6-astra',
	OPENAI_GPT_5_6_SOL = 'gpt-5.6-sol',
	OPENAI_GPT_5_6_TERRA = 'gpt-5.6-terra',
	OPENAI_GPT_5_6_LUNA = 'gpt-5.6-luna',
	OPENAI_GPT_5_4_MINI = 'gpt-5.4-mini',
	OPENAI_GPT_5_4_NANO = 'gpt-5.4-nano',
	// Gemini
	GOOGLE_GEMINI_3_FLASH_PREVIEW = 'gemini-3-flash-preview',
	GOOGLE_GEMINI_3_5_FLASH_LITE = 'gemini-3.5-flash-lite',
	GOOGLE_GEMINI_3_6_FLASH = 'gemini-3.6-flash',
	GOOGLE_GEMINI_3_7_FLASH = 'gemini-3.7-flash',
	GOOGLE_GEMINI_3_8_FLASH = 'gemini-3.8-flash',
	// Qwen
	QWEN_3_6_SELF_HOSTED = 'qwen3.6-self-hosted',
	QWEN_3_6_PLUS = 'qwen3.6-plus',
	QWEN_3_7_MAX = 'qwen3.7-max',
	QWEN_3_7_FLASH = 'qwen3.7-flash',
	QWEN_3_7_PLUS = 'qwen3.7-plus',
	QWEN_3_8_FLASH = 'qwen3.8-flash',
	QWEN_3_8_MAX = 'qwen3.8-max',
	// DeepSeek
	DEEPSEEK_V4_FLASH = 'deepseek-v4-flash',
	DEEPSEEK_V4_PRO = 'deepseek-v4-pro',
}

export enum EmbeddedModelsEnum {
	OPENAI = 'OPENAI',
	QWEN_8B = 'QWEN_8B',
	QWEN_V4 = 'QWEN_V4',
}
